import React, { useEffect, useState, useRef } from "react";
import { copySpecificDates, getMediumSchedulesList, copyWeeklyDates, replaceSchedule, copySelectedDates } from "../../../../services/medium";
import { items } from "../data";
import { el } from "date-fns/locale";
import { toast } from "react-toastify";

export default function CopyModal({ openScheduleForm, backUpItem, is_group_session, CopyModalHandler1, activemedium_availability_id, callBackSchedules, setOpenCopy1,medium_id }) {
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [copyType, setCopyType] = useState(false);
  const [countryType, setCountryType] = useState(""); // default selected option
  const [showTable, setShowTable] = useState(false);
  const [checkboxItems, setcheckboxItems] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [copyBlocked, setCopyBlocked] = useState("0");
  const [selectedItems, setSelectedItems] = useState([]);
  
   const popupRef = useRef(null);


  const handleChange1 = (e) => {
    const value = parseInt(e.target.value); // convert to number if schedule_id is number
    const checked = e.target.checked;

    setSelectedItems((prev) =>
      checked ? [...prev, value] : prev.filter((id) => id !== value)
    );
  };
const handleChange2 = (e) => {
    // Toggle between "0" and "1"
    const newValue = e.target.checked ? "1" : "0";
    setCopyBlocked(newValue);
    console.log("copyBlocked:", newValue);
  };
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (value === "3") {
      // If "Whole Schedule" is selected, unselect all others
      if (checked) {
        setSelectedOptions(["3"]);
      } else {
        setSelectedOptions([]);
      }
    } else {
      // If another option is selected, remove "Whole Schedule" if present
      setSelectedOptions((prevSelected) => {
        let updated = prevSelected.filter((val) => val !== "3");
        if (checked) {
          return [...updated, value];
        } else {
          return updated.filter((val) => val !== value);
        }
      });
    }
    setSelectedCountries(value);
    // if (checked) {
    //   setSelectedCountries((prev) => [...prev, value]);
    // } else {
    //   setSelectedCountries((prev) => prev.filter((item) => item !== value));
    // }
  };

  const handleChange = (e) => {
    let value = e.target.value;
    // setCopyType(value == "1" ? false : true);
    
    setCountryType(e.target.value);
  };

  useEffect(() => {
    if (countryType === "1" ||  countryType === "3") {
      getSchedules();

    }
    if (countryType === "1" || countryType === "3") {
      setShowTable(true)
    }
    else {
      setShowTable(false)
    }
  }, [countryType]);


  const getSchedules = () => {
    let body = {
      get_group_schedules: is_group_session === 0 ? 'no' : 'yes',
      from_schedule_id: activemedium_availability_id,
      medium_id: Number(medium_id),
    }; 
    getMediumSchedulesList(body)
      .then((data) => {
        if (data.data.status) {
          console.log(data.data.data);
          setcheckboxItems(data.data.data)
        }
      })
      .catch(() => { });
  };
  const blockedDatesHandler = () => {
    console.log(countryType, "countryType")
    if (selectedOptions.length === 1 && selectedOptions[0] === "4") {
      window.loadModal2("#CopyModal", "hide");
      CopyModalHandler1(backUpItem)
      // setCopyType(false);
    }
    else if (selectedCountries === "2") {

    }

  }
  const copySpecificDatesHandler = (selectedLabels) => {
    let body = {
      from_schedule_id: activemedium_availability_id,
      to_schedule_id: selectedItems.join(','),
      labels : selectedLabels.join(',') ,
      copy_blocked: copyBlocked
    }
    copySelectedDates(body).then((data) => {
      if (data.data.status) {
        toast.success(data.data.message, { position: "top-center" });
        callBackSchedules();
        window.loadModal2("#CopyModal", "hide");
        window.removeBackdrop()
        // setTimeout(() => {
        //     setOpenCopy2(false);
        // }, 100);
      }
      else {
        toast.error(data.data.message, { position: "top-center" });
      }

    }).catch(() => {

      toast.error("Something went wrong", { position: "top-center" });
    })


  }
   const copyWeeklyDatesHandler = () => {
    let body = {
      from_schedule_id: activemedium_availability_id,
      to_schedule_id: selectedItems.join(',')
    }
    copyWeeklyDates(body).then((data) => {
      if (data.data.status) {
        toast.success(data.data.message, { position: "top-center" });
        callBackSchedules();
        window.loadModal2("#CopyModal", "hide");
        window.removeBackdrop()
        // setTimeout(() => {
        //     setOpenCopy2(false);
        // }, 100);
      }
      else {
        toast.error(data.data.message, { position: "top-center" });
      }

    }).catch(() => {

      toast.error("Something went wrong", { position: "top-center" });
    })


  }
  const replaceScheduleHandler = () => {
    let body = {
      from_schedule_id: activemedium_availability_id,
      to_schedule_id: selectedItems.join(','),
      copy_blocked: copyBlocked
    }
    console.log(body,"body");
    replaceSchedule(body).then((data) => {
      if (data.data.status) {
        toast.success(data.data.message, { position: "top-center" });
        callBackSchedules();
        window.loadModal2("#CopyModal", "hide");
        window.removeBackdrop()
        // setTimeout(() => {
        //     setOpenCopy2(false);
        // }, 100);
      }
      else {
        toast.error(data.data.message, { position: "top-center" });
      }

    }).catch(() => {

      toast.error("Something went wrong", { position: "top-center" });
    })


  }
  const submitHandler = () => {
  const optionLabels = {
    "1": "Weekly Dates",
    "2": "Specific Dates",
    "4": "Blocked Dates",
  };
  const optionLabelsAPI = {
    "1": "WeeklyDatesSchedule",
    "2": "SpecificDatesSchedule",
    "4": "BlockDatesSchedule",
  };
  let  selectedLabels;
    
  if(selectedCountries == 3){
    selectedLabels = ["Weekly Dates","Specific Dates", "Blocked Dates"];
  }else{
    selectedLabels = selectedOptions.map((opt) => optionLabels[opt]);
  }
   
    if (countryType === "2") {
     
      openScheduleForm(activemedium_availability_id, 'copyType', selectedLabels);
      return;
    }
    if (countryType === "1" && selectedOptions.some((val) => ["1", "2", "4"].includes(val))){
       let optionSelectedLabels = selectedOptions.map((opt) => optionLabelsAPI[opt]);
        copySpecificDatesHandler(optionSelectedLabels)

    }
    // if (countryType === "1" && selectedCountries === "1") {
    //   copyWeeklyDatesHandler()
    //   console.log("selectedItems", selectedItems)

    // }
     if (countryType === "3" && selectedCountries === "3") {
      replaceScheduleHandler()
      console.log("selectedItems", selectedItems)

    }
  }

  const backHandler = () => {
    setCopyType(false);
    setShowTable(false);
    setCopyBlocked("0");
    setCountryType("");
    // setSelectedCountries([])
    setcheckboxItems([])
    setSelectedItems([])

  }
  // 👇 Your custom function
  const handleBeforeClose = () => {
    setCopyType(false);
    setShowTable(false);
    setSelectedOptions([]);
    setCountryType("");
    setCopyBlocked("0");
    setSelectedCountries([])
    setcheckboxItems([])
    setSelectedItems([])
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleBeforeClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleSubmitClick = () => {
  if (
    ((countryType === "1" || countryType === "3") && selectedItems.length !== 0) ||
    countryType === "2"
  ) {
    submitHandler(); 
  } else {
    return; 
  }
};
  return (
    <div>
      <div
        id="CopyModal"
        className="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        ref={popupRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-header position-relative">
              <h5 className="modal-title" id="exampleModalLabel">
                Copy Availability
              </h5>
            </div>

            <div className="meeting-preferences-box-row mb-2 mt-5 clear-both">
              {console.log(copyType, "copyType")}
              {!copyType ? (
                <h4 className="text-center">What would you like to copy?</h4>
              ) : (
                <h4 className="text-center">
                  What Schedule would you like to copy to?
                </h4>
              )}
              {copyType ? (
                <div className="language-box--row clear-both  d-flex align-items-center justify-content-center mb-4">
                  {/* <span>Countries</span> */}
                  <div className="ml-3">
                    {selectedCountries != "3" && <div className="check-field">
                      <input
                        type="radio"
                        id="allcountries1"
                        value="1"
                        name="country_type1"
                        checked={countryType === "1"}
                        onChange={handleChange}
                      />
                      <label htmlFor="allcountries1">
                        Copy To Existing Schedule
                      </label>
                    </div>}
                    <div className="check-field">
                      <input
                        type="radio"
                        id="exclusioncountries1"
                        value="2"
                        name="country_type1"
                        checked={countryType === "2"}
                        onChange={handleChange}
                      />
                      <label htmlFor="exclusioncountries1">
                        Create New Schedule
                      </label>
                    </div>
                    {selectedCountries == "3" && <div className="check-field">
                      <input
                        type="radio"
                        id="allcountries1"
                        value="3"
                        name="country_type1"
                        checked={countryType === "3"}
                        onChange={handleChange}
                      />
                      <label htmlFor="allcountries1">
                        Replace Existing Schedule
                      </label>
                    </div>}
                  </div>
                </div>
              ) : (
                <div className="language-box--row clear-both d-flex align-items-center justify-content-center mb-4">
                  {/* <span>Countries</span> */}
                  <div className="ml-3">
                    <div className="check-field">
                      <input
                        type="checkbox"
                        id="selectedcountries"
                        value="3"
                       checked={selectedOptions.includes("3")}
                        onChange={handleCheckboxChange}
                        name="selectedCountries1"
                      />
                      <label htmlFor="selectedcountries">Whole Schedule </label>
                    </div>
                    <div className="check-field">
                      <input
                        type="checkbox"
                        id="allcountries"
                        value="1"
                        checked={selectedOptions.includes("1")}
                        onChange={handleCheckboxChange}
                        name="selectedCountries1"
                      />
                      <label htmlFor="allcountries">Weekly Dates</label>
                    </div>
                    <div className="check-field">
                      <input
                        type="checkbox"
                        id="exclusioncountries"
                        value="2"
                        checked={selectedOptions.includes("2")}
                        onChange={handleCheckboxChange}
                        name="selectedCountries1"
                      />
                      <label htmlFor="exclusioncountries">Specific Dates</label>
                    </div>
                    <div className="check-field">
                      <input
                        type="checkbox"
                        id="exclusioncountries4"
                        value="4"
                        checked={selectedOptions.includes("4")}
                        onChange={handleCheckboxChange}
                        name="selectedCountries4"
                      />
                      <label htmlFor="exclusioncountries4">Blocked Dates</label>
                    </div>
                    {/* {countryType.includes('2') && */}

                    {/* } */}
                  </div>
                </div>
              )}
            </div>
            {showTable && (
              <div className="availability-window-table availability-window-table-1">
                <table>
                  {checkboxItems.map((item) => (
                   
                    <tr>
                      <td>
                        <div class="form-group">
                          <input
                            type="checkbox"
                            value={item.schedule_id}
                            checked={selectedItems.includes(item.schedule_id)}
                            onChange={handleChange1}
                            className="mr-2"
                            name={item.session_name}
                            id={item.session_name}
                          />
                          <label htmlFor={item.session_name}>{item.session_name}</label>
                        </div>
                      </td>
                      
                    </tr>
                    
                    
                  ))}
                    {checkboxItems.length > 0 ? (
                  <tr>
                      <td>
                        <div className="form-group">
                          <input
                            type="checkbox"
                            onChange={handleChange2}
                            checked={copyBlocked === "1"} // checked when value is "0"
                            className="mr-2"
                            name="copy_blocked"
                            id="copy_blocked"
                          />
                          <label htmlFor="copy_blocked">
                            <b>Would you like to copy Blocks to All Sessions?</b>
                          </label>

                          {/* Optional: For form submission */}
                          <input
                            type="hidden"
                            name="copy_blocked"
                            value={copyBlocked}
                          />
                        </div>
                      </td>
                    </tr>
                     ) : (
                      <tr>
                        <td>
                          <span style={{ textAlign: "center",width: "unset",paddingBottom : "19px" }}>
                            No Sessions Available to Copy. Please select a different option.
                          </span>
                        </td>
                      </tr>
                    )}
                </table>
              </div>
            )}
            <div className="d-flex align-items-center justify-content-center mb-5">
              {!copyType && (
                <>
                  <button
                    onClick={() => { setOpenCopy1(false); }}
                    data-dismiss="modal"
                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={() => {  if (selectedOptions.length === 0) return; setCopyType(true); blockedDatesHandler(); }}
                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                  >
                    Next
                  </button>
                </>
              )}

              {copyType == true && (
                <>
                  <button
                    onClick={backHandler}
                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                  >
                    Back
                  </button>
                  <button
                    // onClick={() => setCopyType(false)}
                    onClick={handleSubmitClick}
                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                  >
                    Submit
                  </button>
                </>
              )}
            </div>
            {/* Debug: You can remove this */}
            {/* <div className="p-3">
              <strong>Selected:</strong> {selectedCountries.join(", ")}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
